import {
    GET_EMPLOYEE_CAREER_PATH_REQUEST, GET_EMPLOYEE_CAREER_PATH_SUCCESS, GET_EMPLOYEE_CAREER_PATH_FAIL,
    GET_ALL_EMPLOYEE_CAREER_PATHS_REQUEST, GET_ALL_EMPLOYEE_CAREER_PATHS_SUCCESS, GET_ALL_EMPLOYEE_CAREER_PATHS_FAIL,
    GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_REQUEST, GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_SUCCESS, GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_FAIL,
    ASSIGN_CAREER_PATH_REQUEST, ASSIGN_CAREER_PATH_SUCCESS, ASSIGN_CAREER_PATH_FAIL,
    UPDATE_EMPLOYEE_CAREER_PATH_REQUEST, UPDATE_EMPLOYEE_CAREER_PATH_SUCCESS, UPDATE_EMPLOYEE_CAREER_PATH_FAIL,
    UPDATE_EMPLOYEE_CAREER_PATH_STATUS_REQUEST, UPDATE_EMPLOYEE_CAREER_PATH_STATUS_SUCCESS, UPDATE_EMPLOYEE_CAREER_PATH_STATUS_FAIL,
    DELETE_EMPLOYEE_CAREER_PATH_REQUEST, DELETE_EMPLOYEE_CAREER_PATH_SUCCESS, DELETE_EMPLOYEE_CAREER_PATH_FAIL,
    SET_EMPLOYEE_CAREER_PATH_LOADING
} from '../actions/employeeCareerPathActions';

const initialState = {
    employeeCareerPaths: [],
    currentEmployeeCareerPath: null,
    loading: false,
    error: null
};

function employeeCareerPathReducer(state = initialState, action) {
    switch (action.type) {

        case SET_EMPLOYEE_CAREER_PATH_LOADING:
            return { ...state, loading: action.payload };

        case GET_EMPLOYEE_CAREER_PATH_REQUEST:
        case GET_ALL_EMPLOYEE_CAREER_PATHS_REQUEST:
        case GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_REQUEST:
        case ASSIGN_CAREER_PATH_REQUEST:
        case UPDATE_EMPLOYEE_CAREER_PATH_REQUEST:
        case UPDATE_EMPLOYEE_CAREER_PATH_STATUS_REQUEST:
        case DELETE_EMPLOYEE_CAREER_PATH_REQUEST:
            return { ...state, loading: true, error: null };

        case GET_EMPLOYEE_CAREER_PATH_SUCCESS:
            return { ...state, loading: false, currentEmployeeCareerPath: action.payload };

        case GET_ALL_EMPLOYEE_CAREER_PATHS_SUCCESS:
        case GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_SUCCESS:
            return { ...state, loading: false, employeeCareerPaths: action.payload };

        case ASSIGN_CAREER_PATH_SUCCESS:
            return {
                ...state,
                loading: false,
                employeeCareerPaths: [...state.employeeCareerPaths, action.payload]
            };

        case UPDATE_EMPLOYEE_CAREER_PATH_SUCCESS:
            return {
                ...state,
                loading: false,
                employeeCareerPaths: state.employeeCareerPaths.map(ecp =>
                    ecp.id === action.payload.id ? action.payload : ecp
                ),
                currentEmployeeCareerPath: state.currentEmployeeCareerPath?.id === action.payload.id
                    ? action.payload : state.currentEmployeeCareerPath
            };

        case UPDATE_EMPLOYEE_CAREER_PATH_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                employeeCareerPaths: state.employeeCareerPaths.map(ecp =>
                    ecp.id === action.payload.id
                        ? { ...ecp, status: action.payload.status }
                        : ecp
                )
            };

        case DELETE_EMPLOYEE_CAREER_PATH_SUCCESS:
            return {
                ...state,
                loading: false,
                employeeCareerPaths: state.employeeCareerPaths.filter(ecp => ecp.id !== action.payload.id),
                currentEmployeeCareerPath: state.currentEmployeeCareerPath?.id === action.payload.id
                    ? null : state.currentEmployeeCareerPath
            };

        case GET_EMPLOYEE_CAREER_PATH_FAIL:
        case GET_ALL_EMPLOYEE_CAREER_PATHS_FAIL:
        case GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_FAIL:
        case ASSIGN_CAREER_PATH_FAIL:
        case UPDATE_EMPLOYEE_CAREER_PATH_FAIL:
        case UPDATE_EMPLOYEE_CAREER_PATH_STATUS_FAIL:
        case DELETE_EMPLOYEE_CAREER_PATH_FAIL:
            return { ...state, loading: false, error: action.error };

        default:
            return state;
    }
}

export default employeeCareerPathReducer;